import {SupportTriggerPointTriggerPoint} from '../../generated/types';

const AssistantTriggerPoints: SupportTriggerPointTriggerPoint[] = [
  'assistant_search_result_direct',
  'assistant_search_result_suggested_query',
  'assistant_onboarding',
];

const StartFreshTriggerPoints: SupportTriggerPointTriggerPoint[] = [
  'assistant_search_result_direct',
  'assistant_search_result_suggested_query',
  'assistant_onboarding',
];

const RestartableTriggerPoints: SupportTriggerPointTriggerPoint[] = [
  'assistant_drawer_internal',
  'dashboard_help_menu_contact_support',
  'dashboard_help_icon',
];

export function isAssistantTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    AssistantTriggerPoints.includes(
      triggerPoint as SupportTriggerPointTriggerPoint,
    )
  );
}

export function isDotComCsfTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return !!triggerPoint && triggerPoint === 'dot_com_embedded_csf';
}

export function isStartFreshTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    StartFreshTriggerPoints.includes(
      triggerPoint as SupportTriggerPointTriggerPoint,
    )
  );
}

export function isRestartableTriggerPoint(
  triggerPoint?: SupportTriggerPointTriggerPoint | string,
): boolean {
  return (
    !!triggerPoint &&
    RestartableTriggerPoints.includes(
      triggerPoint as SupportTriggerPointTriggerPoint,
    )
  );
}
